import React from "react";
import {Outlet} from "react-router-dom";

const LoggedInLayout = () => {
    return <div className="guest-layout">
        <Outlet />
    </div>;
}

export default LoggedInLayout;